<template>
  <DefaultPageLayout class="page-blocker">
    <PageBlockerContent />
  </DefaultPageLayout>
</template>

<script>
import { storeToRefs } from 'pinia'

import DefaultPageLayout from '@/components/layouts/components/page/DefaultPageLayout.vue'

import { useCoreStore } from '../store/useCoreStore'

import PageBlockerContent from './PageBlockerContent.vue'

export default {
  name: 'PageBlocker',
  components: {
    DefaultPageLayout,
    PageBlockerContent,
  },
  created() {
    const { activeBrandLocations } = this

    if (activeBrandLocations.length === 1) {
      this.$router.push({
        name: this.$route.name.replace('brand', 'location'),
        params: {
          brandId: this.$route.params.brandId,
          locationId: activeBrandLocations[0].id,
        },
      })
    }
  },
  setup() {
    const { activeBrandLocations } = storeToRefs(useCoreStore())
    return { activeBrandLocations }
  },
}
</script>

<style lang="scss" scoped>
.page-blocker {
  height: 100%;
  width: 100%;
}
</style>
